import { BISKO_METHODOLOGY_LOOKUP_MAP } from "./methodology-lookup";
const STATIONARY_ENERGY = BISKO_METHODOLOGY_LOOKUP_MAP.sectors.STATIONARY_ENERGY;
const TRANSPORTATION = BISKO_METHODOLOGY_LOOKUP_MAP.sectors.TRANSPORTATION;
export const BISKO_METHODOLOGY_ID = BISKO_METHODOLOGY_LOOKUP_MAP.id;
export const STATIONARY_ENERGY_SECTOR_ID = STATIONARY_ENERGY.id;
export const TRANSPORT_SECTOR_ID = TRANSPORTATION.id;
export const INDUSTRY_SUBSECTOR_ID = STATIONARY_ENERGY.subsectors.INDUSTRY.id;
export const COMMERCE_TRADE_SERVICES_SUBSECTOR_ID = STATIONARY_ENERGY.subsectors.COMMERCE_TRADE_SERVICES.id;
export const HOUSEHOLDS_SUBSECTOR_ID = STATIONARY_ENERGY.subsectors.HOUSEHOLDS.id;
export const PUBLIC_BUILDINGS_SUBSECTOR_ID = STATIONARY_ENERGY.subsectors.PUBLIC_BUILDINGS.id;
export const STREET_LIGHTING_SUBSUBSECTOR_ID = "y5rjq7nunlt1qosz6njjx3kg";
export const SCHOOLS_DAYCARE_SUBSUBSECTOR_ID = "y5rjq7nunlt1qosz6njjx3kf";
export const ADMINISTRATIVE_BUILDINGS_SUBSUBSECTOR_ID = "y5rjq7nunlt1qosz6njjx3ke";
export const MUNICIPAL_INFRASTRUCTURE_SUBSUBSECTOR_ID = "y5rjq7nunlt1qosz6njjx3kh";
export const OTHER_MUNICIPAL_BUILDINGS_SUBSUBSECTOR_ID = "y5rjq7nunlt1qosz6njjx3ki";
// `kind` is copied onto a custom inventory's cloned subsectors and `abbreviation` onto its
// subsubsectors, so they bridge methodology ids to re-keyed inventory rows.
export const PUBLIC_BUILDINGS_SUBSECTOR_KIND = "PUBLIC_BUILDINGS";
export const HOUSEHOLDS_SUBSECTOR_KIND = "HOUSEHOLDS";
export const COMMERCE_TRADE_SERVICES_SUBSECTOR_KIND = "COMMERCE_TRADE_SERVICES";
export const INDUSTRY_SUBSECTOR_KIND = "INDUSTRY";
export const STREET_LIGHTING_SUBSUBSECTOR_ABBREVIATION = "Str. Beleuchtung";
export const SCHOOLS_DAYCARE_SUBSUBSECTOR_ABBREVIATION = "Schulen/Kitas";
export const ADMINISTRATIVE_BUILDINGS_SUBSUBSECTOR_ABBREVIATION = "Verw. Gebäude";
export const MUNICIPAL_INFRASTRUCTURE_SUBSUBSECTOR_ABBREVIATION = "komm. Infrastr.";
export const OTHER_MUNICIPAL_BUILDINGS_SUBSUBSECTOR_ABBREVIATION = "Andere KG";
export const TRANSIT_BUS_SUBSECTOR_ID = TRANSPORTATION.subsectors.TRANSIT_BUS.id;
export const TRAM_METRO_SUBSECTOR_ID = TRANSPORTATION.subsectors.TRAM_METRO.id;
export const LOCAL_RAIL_SUBSECTOR_ID = TRANSPORTATION.subsectors.LOCAL_RAIL.id;
export const MOTORIZED_TWO_WHEELERS_SUBSECTOR_ID = TRANSPORTATION.subsectors.MOTORIZED_TWO_WHEELERS.id;
export const HEAVY_COMMERCIAL_VEHICLES_SUBSECTOR_ID = TRANSPORTATION.subsectors.HEAVY_COMMERCIAL_VEHICLES.id;
export const COACHES_SUBSECTOR_ID = TRANSPORTATION.subsectors.COACHES.id;
export const PASSENGER_CARS_SUBSECTOR_ID = TRANSPORTATION.subsectors.PASSENGER_CARS.id;
export const LIGHT_COMMERCIAL_VEHICLES_SUBSECTOR_ID = TRANSPORTATION.subsectors.LIGHT_COMMERCIAL_VEHICLES.id;
export const DIESEL_FOSSIL_ENERGY_SOURCE_ID = TRANSPORTATION.energySources.DIESEL.id;
export const DIESEL_BIOGENIC_ENERGY_SOURCE_ID = TRANSPORTATION.energySources.DIESEL_BIOGENIC.id;
